import {isMobileDevice} from "../../common/GUIUtilities";
import {userCanAction} from "../../login/Security";
import {areNotEqual, isEmptyOrNull} from "../../common/NamaCommon";
import * as CommonConstants from "../../constants/CommonConstants";

function addMoreItemToMenu(buttonData, menu, buttonIndex) {
    let isSeparator = buttonData.id == CommonConstants.MORE_MENU_SEPERATOR;
    if (isSeparator && !menu.find('li:last-child').hasClass('k-separator')) {
        menu.append(`<li class="k-separator"></li>`);
    } else if (!isSeparator) {
        if (!buttonData.subItems) {
            menu.append(`<li id = ${buttonData.id} btnIndex = ${buttonIndex}>${buttonData.title}</li>`);
        }
        if (buttonData.subItems) {
            menu.append(`<li id = ${buttonData.id}>${buttonData.title}<ul id = ${buttonData.id}></ul></li>`);
            let ul = menu.find(`ul#${buttonData.id}`);
            for (let subItem of buttonData.subItems) {
                addMoreItemToMenu(subItem, ul);
            }
        }
    }
}

function findButtonDataWithId(id, buttonsData) {
    let allButtons = [];
    for (let button of buttonsData) {
        if (!button.id)
            continue;
        allButtons.push(button);
        if (button.subItems)
            for (let subItem of button.subItems) {
                allButtons.push(subItem);
            }
    }
    for (let button of allButtons) {
        if (button.id === id)
            return button;
    }
}

function destroyMenu(menu, presenter) {
    let allMenus = $("#moreActionsMenu");
    if (allMenus.length) {
        for (let m of allMenus) {
            if (m.data && m.data("kendoContextMenu"))
                m.data("kendoContextMenu").destroy();
            m.closest(".k-popups-wrapper").remove();
        }
    }
    $("body").remove("#moreActionsMenu");
    presenter.moreMenuIsOpened = false;
}

/**
 *
 * @param buttonsData {MoreMenuItem[]}
 * @param toolBar
 * @param presenter
 */
export function constructMoreActionsMenu(buttonsData, toolBar, presenter) {
    let menu = $(`<ul id='moreActionsMenu'></ul>`);
    menu.appendTo("body");
    for (let buttonData of buttonsData) {
        if (areNotEqual(buttonData.id, CommonConstants.MORE_MENU_SEPERATOR) && (!userCanAction(presenter.entityType, buttonData.securityID || buttonData.id) || isEmptyOrNull(buttonData.title)))
            continue;
        addMoreItemToMenu(buttonData, menu, buttonsData.indexOf(buttonData));
    }
    menu.kendoContextMenu({
        target: isMobileDevice() ? toolBar : toolBar.find("#moreMenu"),
        scrollable: true,
        orientation: "vertical",
        select: e => {
            let selectedButtonData = findButtonDataWithId(e.item.id, buttonsData) || buttonsData[$(e.item).attr("btnIndex")];
            if (selectedButtonData.clickFunction)
                selectedButtonData.clickFunction();
            destroyMenu(menu, presenter);
        },
        open: function (e) {
            if ($(e.item).length && $(e.item).parent().attr("id") === "moreActionsMenu" && $(e.item).find("li").length > 0)
                return;
            if (presenter.moreMenuIsOpened) {
                e.preventDefault();
                return;
            }
            presenter.moreMenuIsOpened = true;
        },
        close: function (e) {
            destroyMenu(menu, presenter);
        }
    });
    menu.data("kendoContextMenu").open();
    menu.parent(".k-animation-container").css("z-index", 10003);
}
